<template>
  <div>
    <hshead title="用户信息" bgcolor="#fff"></hshead>
    <div>
      <van-cell-group>
        <van-field v-model="tempData.mobile" label="手机号码" input-align="right" disabled />
        <van-field v-model="tempData.userName" label="姓名" input-align="right" disabled />
        <van-cell-group>
          <van-cell title="性别">
            <van-radio-group v-model="tempData.sex">
              <van-radio name="1">男</van-radio>
              <van-radio name="2">女</van-radio>
            </van-radio-group>
          </van-cell>
        </van-cell-group>
        <van-field
          v-model="tempData.birthday"
          label="生日"
          placeholder="选择生日"
          @click="dateFieldClick('birthday', tempData.birthday)"
          input-align="right"
          readonly
        />
        <van-field
          v-model="tempData.areaName"
          label="城市"
          placeholder="选择城市"
          @click="choiceCity()"
          input-align="right"
          readonly
        />
        <van-field
          v-model="tempData.iDCard"
          label="身份证"
          placeholder="填写身份证"
          maxlength="18"
          input-align="right"
        />
      </van-cell-group>
      <van-cell>
        <van-button type="info" size="large" class="my-btn" @click="handleUpdateUser">确定修改</van-button>
      </van-cell>
    </div>

    <van-popup v-model="showPopup" :close-on-click-overlay="false" position="bottom">
      <van-datetime-picker
        v-model="curSelectedDate"
        type="date"
        placeholder="日期"
        @confirm="datePickerConfirm"
        @cancel="datePickerCancel"
        :min-date="minDate"
        :max-date="maxDate"
      />
    </van-popup>

    <van-popup v-model="showPopup2" :close-on-click-overlay="false" position="bottom">
      <van-picker
        :columns="areaColumns"
        @confirm="cityConfirm"
        @cancel="cityCancel"
        @change="cityChange"
        placeholder="==选择省份=="
        :showToolbar="true"
      />
    </van-popup>
    <city
      :is-show.sync="city.isShow"
      :on-choose="city.onChoose"
      :city-data="city.cityData"
      :local-city="city.localCity"
      :close="close"
    ></city>
  </div>
</template>

<script>
import globalMixinBox from "@/assets/js/mixin.js";
import $ from "jquery";
import hshead from "@/components/common/hshead";

import moment from "moment";
import {
  Toast,
  List,
  CellGroup,
  Cell,
  Field,
  Button,
  RadioGroup,
  Radio,
  Popup,
  DatetimePicker,
  Picker
} from "vant";
import { getUser, updateUser } from "@/api/m/user";
import { getCascaderData } from "@/api/m/shootCity";
import { idCardRegex } from "@/constant/regexExp";

export default {
  name: "userInfo",
  mixins: [globalMixinBox.areaMixin],
  data() {
    return {
      tempData: {},
      //
      showPopup: false,
      showPopup2: false,
      curSelectedDate: new Date(),
      curClickedField: "",
      //
      citys: {},
      areaColumns: null,
      cascaderData: {},

      minDate: new Date("1900"),
      maxDate: new Date()
    };
  },
  created() {
    //
    this.getUser();
  },
  methods: {
    getUser() {
      this.load(true, "加载中...");
      getUser()
        .then(response => {
          this.load(false);
          this.tempData = response;
          this.tempData.areaName = response.cityName;
          // this.tempData.areaName = this.returnCityName(response.cityId);
          //城市列表数据
          //this.getCascaderData();
        })
        .catch(response => {
          this.load(false);
          //this.tips(`${response}`);
          Toast.fail({ duration: 1000 * 5, message: `${response}` });
        });
    },
    //城市列表数据
    getCascaderData() {
      getCascaderData()
        .then(response => {
          console.info("response", response);
          const { code, msg, data } = response;
          if (code >= 0) {
            console.info("getCascaderData -> data", data);
            this.cascaderData = data;
            let curProvinceIdx = 0;
            let curCityIdx = 0;
            data[0].children.map((provinceObj, provinceIdx) => {
              //console.info('provinceObj, provinceIdx', provinceObj, provinceIdx)
              let arrCityName = [];
              provinceObj.children.map((cityObj, cityIdx) => {
                //console.info('cityObj, cityIdx', cityObj, cityIdx)
                arrCityName.push(cityObj.label);
                if (cityObj.value == this.tempData.cityId) {
                  curProvinceIdx = provinceIdx;
                  curCityIdx = cityIdx;
                }
              });
              this.citys[provinceObj.label] = arrCityName;
              //console.info('provinceObj.label', provinceObj.label, arrCityName)
              //console.info('citys', this.citys)
            });
            const curProvinceName = data[0].children[curProvinceIdx].label;
            const curCityName =
              data[0].children[curProvinceIdx].children[curCityIdx].label;
            console.info(
              "curProvince",
              curProvinceName,
              curProvinceIdx,
              curCityName,
              curCityIdx
            );
            this.areaColumns = [
              {
                values: Object.keys(this.citys),
                className: "column1",
                defaultIndex: curProvinceIdx
              },
              {
                values: this.citys[curProvinceName],
                className: "column2",
                defaultIndex: curCityIdx
              }
            ];
            if (this.tempData.cityId) {
              this.tempData.areaName = curProvinceName + " " + curCityName;
            }
          }
        })
        .catch(response => {
          //this.tips(`${response.msg}`);
          Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
        });
    },
    handleUpdateUser() {
      const { birthday, cityId, iDCard } = this.tempData;
      if (!birthday) {
        this.tips("请选择生日");
        return;
      }
      if (!cityId) {
        this.tips("请选择城市");
        return;
      }
      if (!idCardRegex.test(iDCard)) {
        this.tips("身份证验证不通过！");
        return;
      }
      const param = this.tempData;
      console.info("param", param);
      this.load(true, "加载中...");
      updateUser(param)
        .then(response => {
          this.load(false);
          const { code, msg, data } = response;
          if (code >= 0) {
            this.tips(`操作成功`);
            setTimeout(function() {
              window.location = "/";
            }, 1000 * 1.5);
          }
        })
        .catch(response => {
          this.load(false);
          //this.tips(response.msg);
          Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
        });
    },
    /************* 日期选择控件 *************/
    dateFieldClick(field, date) {
      this.showPopup = true;
      this.curClickedField = field;
      console.info("date", date, moment(date));
      if (date)
        this.curSelectedDate = new Date(moment(date).format("YYYY-MM-DD"));
    },
    datePickerConfirm(val) {
      this.showPopup = false;
      console.info("datePickerConfirm", val, this.curClickedField);
      this.tempData[this.curClickedField] = moment(val).format("YYYY-MM-DD");
    },
    datePickerCancel() {
      this.showPopup = false;
    },
    /************* 省市选择 *************/
    cityClick() {
      this.showPopup2 = true;
    },
    cityCancel() {
      this.showPopup2 = false;
    },
    cityChange(picker, values) {
      picker.setColumnValues(1, this.citys[values[0]]);
    },
    cityConfirm(picker, values) {
      const provinceName = this.cascaderData[0].children[values[0]].label;
      const cityName = this.cascaderData[0].children[values[0]].children[
        values[1]
      ].label;

      this.tempData.cityId = this.cascaderData[0].children[values[0]].children[
        values[1]
      ].value;
      this.tempData.areaName = provinceName + " " + cityName;

      console.info("cityConfirm", picker, values, this.tempData.cityId);
      this.showPopup2 = false;
    }
  },
  components: {
    hshead,
    "van-list": List,
    "van-cell-group": CellGroup,
    "van-cell": Cell,
    "van-field": Field,
    "van-button": Button,
    "van-radio-group": RadioGroup,
    "van-radio": Radio,
    "van-popup": Popup,
    "van-datetime-picker": DatetimePicker,
    "van-picker": Picker
  },
  watch: {
    city: {
      handler(val, oldVal) {
        if (val.localCity.cityName != "选择城市") {
          this.tempData.areaName = val.localCity.cityName;
          this.tempData.cityId = val.localCity.cityId;
        }
      },
      deep: true
    }
  }
};
</script>

<style lang="less" scoped>
// @import "~@/assets/less/common.less";
// @import "~@/assets/less/mixin.less";
.my-btn {
  border-radius: 1rem !important;
  background-color: #00b8f5 !important;
  font-size: 14px !important;
  border-color: transparent;
  height: 35px;
  line-height: 35px;
}
</style>


// WEBPACK FOOTER //
// src/views/user/userInfo.vue